import { FC, lazy, useEffect } from 'react';
import { PageSpinner } from 'src/components/spinner-container';
import { useAssignmentsOverviewParams } from 'src/pages/operators/assignments/overview/use-overview-params';
import { useGetOldUserIdDeprecated } from 'src/pages/settings/organisation/users/details/use-get-old-user-id';

const Page = lazy(() => import('./page'));

export const monolithAssignmentEndpoints = {
  getDetailsOfAssignment: `${PRISMA_CONFIG.oldBackendUrl}/shipperUsers/{shipperid}/assignments/{tsoid}`,
  getAssignmentsOfOrganisation: `${PRISMA_CONFIG.oldBackendUrl}/shippers/assigned-operators`,
  getAssignmentsOfShipperUser: `${PRISMA_CONFIG.oldBackendUrl}/shippers/{customerUserRefId}/assigned-operators?detailLevel=EXTENDED_PUBLIC`,
  getAllTsos: `${PRISMA_CONFIG.oldBackendUrl}/tso`,
};

export const AssignmentsOverview: FC = () => {
  const getOldUserIds = useGetOldUserIdDeprecated();
  const pageParams = useAssignmentsOverviewParams();
  useEffect(() => {
    getOldUserIds.execute();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!getOldUserIds.response) {
    return <PageSpinner />;
  }

  const customerRefId = getOldUserIds.response.data.customerRefId;
  const customerUserRefId = getOldUserIds.response.data.customerUserRefId;

  return (
    <Page
      customerRefId={customerRefId}
      customerUserRefId={customerUserRefId}
      pageParams={pageParams}
    />
  );
};
